import React from 'react';
import {Grid} from 'react-loader-spinner'
import {Alert} from '@mui/material';
import {userInfoStore} from "../store/UserInfo";
import {userApi} from "../backend/UserApi";
import {sleep} from "../utils/ThreadUtils";

interface IProps {
}

interface IState {
    visible: boolean,
    error: boolean
}

class WakeUpLoader extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            visible: true,
            error: false,
        };
    }

    async componentDidMount() {
        await this.tryWakeUp();
    }

    async tryWakeUp() {
        let counter = 0;
        while (counter < 3) {
            try {
                counter = counter + 1;
                //Speedup the warmup of lambdas
                await Promise.all([userInfoStore.refreshUser(), userApi.fetchUserInfo()]);
                this.setState({visible: false});
                return;
            } catch (error) {
                console.error(error)
                await sleep(30000);
            }
        }
        this.setState({error: true});
    }


    render() {
        if (this.state.error) {
            return (
                    <Alert severity="error">
                        Failed to contact backend
                    </Alert>
            );
        } else if (this.state.visible) {
            return (
                    <div className="loader-center">
                        <Grid
                                color="#00BFFF"
                                height={100}
                                width={100}
                                visible={this.state.visible}
                        />
                    </div>
            );
        } else {
            return this.props.children;
        }
    }
}

export default WakeUpLoader;